// Lib
import { combineReducers } from 'redux-immutable';

// Reducers
import hydration from './hydrationReducer';

export default combineReducers({
    hydration,
});
